import PropTypes from 'prop-types';

export const LayersControlGroup = ({children}) => {
	return <div className="insar-LayersControlGroup">{children}</div>;
};

LayersControlGroup.propTypes = {
	children: PropTypes.node,
};

export const LayersControlGroupHeader = ({children}) => {
	return <h4 className="insar-LayersControlGroup-header">{children}</h4>;
};

LayersControlGroupHeader.propTypes = {
	children: PropTypes.node,
};

export const LayersControlGroupDescription = ({children}) => {
	return <div className="insar-LayersControlGroup-description">{children}</div>;
};

LayersControlGroupDescription.propTypes = {
	children: PropTypes.node,
};

export const LayersControlGroupContent = ({children}) => {
	return <div className="insar-LayersControlGroup-content">{children}</div>;
};

LayersControlGroupContent.propTypes = {
	children: PropTypes.node,
};

export const LayersControlGroupItem = ({children}) => {
	return <div className="insar-LayersControlGroup-item">{children}</div>;
};

LayersControlGroupItem.propTypes = {
	children: PropTypes.node,
};
